<template>
  <div class="space-y-2">
    <span class="text-sm font-medium text-gray-700">{{ attributeName }}</span>
    <div class="flex flex-wrap gap-4">
      <div v-for="term in terms" :key="term.id" class="flex flex-col items-center gap-1">
        <button class=" rounded-full transition-all duration-200 relative" :class="{
          'ring-2 ring-orange-500 ring-offset-2': isSelected(term),
          'ring-2 ring-gray-200 ring-offset-2':
            !isSelected(term)
        }" @click="handleColorSelect(term)">
          <div class="rounded-full overflow-hidden">
            <NuxtImg v-if="getColorTermImage(term)" :src="`cl/${getColorTermImage(term)}`" width="50" height="50"
              fit="inside" background="white" :alt="term.term_value" />
            <img v-else :src="`https://placehold.co/100x100?text=${term.name}`" class="w-full h-full object-cover"
              :alt="term.term_value" />
          </div>
          <div v-if="!variationStore.isTermAvailable(attributeName, term.name)"
            class="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white flex items-center justify-center border border-gray-200">
            <Icon name="heroicons:x-mark" class="w-3 h-3 text-gray-400" />
          </div>
        </button>
        <span class="text-xs text-gray-600" :class="{ 'font-medium text-orange-600': isSelected(term) }">
          {{ term.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
const { API_ENDPOINTS } = useApiEndpoints()
const productDetailsStore = useProductDetailsStore()
const variationStore = useBuyboxVariationsStore()

const props = defineProps({
  attributeName: {
    type: String,
    required: true
  },
  terms: {
    type: Array,
    required: true,
    default: () => []
  },
  productId: {
    type: Number,
    required: true
  }
})

const isSelected = (term) => {
  return variationStore.selectedTerms[props.attributeName] === term.name
}

// Ürün galerisine kaydırma işlemi
const scrollToProductGallery = () => {
  if (!process.client) return

  setTimeout(() => {
    const galleryElement = document.getElementById('product-gallery')
    if (galleryElement) {
      // Galeri elementinin pozisyonunu al
      const galleryRect = galleryElement.getBoundingClientRect()
      const isVisible = galleryRect.top >= -100 && galleryRect.top <= 120

      // Eğer galeri zaten görünür alanda değilse kaydır
      if (!isVisible) {
        galleryElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, 100)
}

const handleColorSelect = async (term) => {
  const selectedColorTerm = productColorTermsWithImages.value.find((item) => {
    return item.product_attribute_term_id === term.id
  })

  if (selectedColorTerm) {
    productDetailsStore.setProductImages(selectedColorTerm.images)
  }

  variationStore.selectTerm(props.attributeName, term.name)

  // Ürün galerisine kaydır
  scrollToProductGallery()
}

const productColorTermsWithImages = ref([])

const fetchProductColorTermsImages = async () => {
  const response = await useBaseOFetchWithAuth(
    API_ENDPOINTS.public.products.colorTermsWithImages(props.productId)
  )
  productColorTermsWithImages.value = response
}

const getColorTermImage = (term) => {
  const colorTerm = productColorTermsWithImages.value.find(
    (item) => item.product_attribute_term_id === term.id
  )
  return colorTerm?.images?.[0]?.path || null
}

onMounted(async () => {
  await fetchProductColorTermsImages()
})
</script>
